// packages
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// types
import { UserProps } from '@/entities/user'

// interfaces
interface AuthState {
  user: UserProps | null
  token: string | null
  isAuthenticated: boolean
  setUser: (user: UserProps) => void
  login: (user: UserProps, token: string) => void
  logout: () => void
  updateBalance: (newBalance: number) => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    set => ({
      user: null,
      token: null,
      isAuthenticated: false,
      setUser: user => {
        set({ user })
      },
      login: (user, token) => {
        set({
          user,
          token,
          isAuthenticated: true
        })
      },
      logout: () => {
        set({
          user: null,
          token: null,
          isAuthenticated: false
        })

        window.location.href = '/login'
      },
      updateBalance: (newBalance: number) => {
        set(state => ({
          ...state,
          user: {
            ...(state.user as UserProps),
            balance: newBalance
          }
        }))
      }
    }),
    {
      name: `${import.meta.env.VITE_APP_NAME}-auth-storage`
    }
  )
)
